import type { HelpFile } from '../../types/help'
import { LanguageSwitcherTestIds } from '../../../testids/LanguageSwitcherTestIds'

// Auswahl in der Kopfleiste — das aria-label beschreibt die Aktion.
export const languageSwitcherHelp: HelpFile = {
  docPage: '/docs/help-system/language',
  texts: {
    [LanguageSwitcherTestIds.btnLanguageSwitcher]: null,
  },
}
